<template>
  <div class="checkItemWrapper" v-bind:style="style.flex">
    <img class="checkButton" v-bind:src="checkBoxImg" v-on:click="onCheckButton">
    <span>{{text}}</span>
  </div>
</template>

<script>

export default {
  props: {
    type: String,
    itemKey: [String, Number],
    text: String,
    flexRatio: Number
  },
  data () {
    return {
      checkBoxImg: '',
      style: {
        flex: 'flex-grow: 0; flex-shrink: 0; flex-basis: calc(' + 100 / this.flexRatio + '% - 20px);'
      }
    }
  },
  methods: {
    onCheckButton: function () {
      this.$store.commit('setEnrollStateValue', {type: this.type, value: this.itemKey})
      if(this.type === 'reward') {
        // 체크버튼 타입이 보상방법일 경우 AdUI에 값 추가
        this.$store.commit('setAdUiStateValue', {type: 'isRewardTypeCoupon', value: this.itemKey === 'COUPON' || this.itemKey === 'ALL'})
      }else if(this.type === 'category') {
        // 체크버튼 타입이 카테고리일 경우 AdUI에 값 추가
        this.$store.commit('setAdUiStateValue', {type: 'category', value: this.text})
      }
    }
  },
  created: function () {
    this.checkBoxImg = this.$store.getters.getEnrollStateValue(this.type) === this.itemKey ? require('@/assets/img/checkbox_selected_img.png') : require('@/assets/img/checkbox_not_selected_img.png')
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getEnrollStateValue(this.type), value => {
      this.checkBoxImg = value === this.itemKey ? require('@/assets/img/checkbox_selected_img.png') : require('@/assets/img/checkbox_not_selected_img.png')
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.checkItemWrapper {
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  padding-right: 20px;
  padding-bottom: 10px;
}

.checkItemWrapper > span {
  margin-left: 5px;
  font-size: 13px;
}

.checkButton{
  cursor: pointer;
  width: 32px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/checkItem.vue